import { c as _c } from "react/compiler-runtime";
import { FlowAd } from ".";
type Props = React.PropsWithChildren<{
  index: number;
}>;
export default function FlowAdWrapper(t0) {
  const $ = _c(8);
  const {
    children,
    index
  } = t0;
  let t1;
  if ($[0] !== index) {
    t1 = index === 0 && <FlowAd />;
    $[0] = index;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== index) {
    t2 = (index + 1) % 10 === 0 && <FlowAd />;
    $[2] = index;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== children || $[5] !== t1 || $[6] !== t2) {
    t3 = <>{t1}{children}{t2}</>;
    $[4] = children;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}